module.exports = __webpack_public_path__ + "static/assets/c5028d91a0739807ae925a7167c23d59.png";